import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";

const Services = () => {
    const [services, setServices] = useState([]);
    useEffect(() => { api.get("/services").then(r => setServices(r.data)); }, []);

    return (
        <div data-testid="services-page" className="pt-32 pb-24 bg-bg-base">
            <section className="px-6 md:px-12 mb-16">
                <div className="max-w-7xl mx-auto text-center">
                    <div className="text-xs uppercase tracking-[0.4em] text-gold mb-5">What We Offer</div>
                    <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white leading-tight">
                        Premium Event <span className="italic gold-text-gradient">Effects</span>
                    </h1>
                    <p className="mt-6 text-white/70 max-w-2xl mx-auto leading-relaxed">
                        From cold pyro varmala to grand corporate launches — explore the full Star Events catalogue.
                    </p>
                </div>
            </section>

            <section className="px-6 md:px-12">
                <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {services.map((s) => (
                        <div
                            key={s.id}
                            data-testid={`service-${s.id}`}
                            className="zoom-on-hover group relative overflow-hidden rounded-xl border border-white/10 bg-bg-surface hover:border-gold/50 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_20px_60px_-20px_rgba(212,175,55,0.25)]"
                        >
                            <div className="aspect-[4/3] overflow-hidden">
                                <img src={s.image_url} alt={s.title} className="w-full h-full object-cover" loading="lazy" />
                            </div>
                            <div className="p-6">
                                <h3 className="font-serif text-xl md:text-2xl text-white mb-3">{s.title}</h3>
                                <p className="text-sm text-white/65 leading-relaxed mb-5 min-h-[60px]">{s.description}</p>
                                <Link
                                    to="/contact"
                                    state={{ service: s.title }}
                                    data-testid={`service-enquire-${s.id}`}
                                    className="inline-flex items-center gap-2 text-gold hover:text-gold-hover text-sm font-semibold transition-colors"
                                >
                                    Enquire <ArrowRight size={14} />
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default Services;
